import React from "react";
import { useReactPWAInstall } from "react-pwa-install";
import myLogo from "../../Assets/logo192.png";

import {
    AiOutlineAppstoreAdd,
  } from "react-icons/ai";

function Install() {
  const { pwaInstall, supported, isInstalled } = useReactPWAInstall();

  const handleClick = () => {
    pwaInstall({
      title: "Installa App Baes-Studio",
      logo: myLogo,
      features: (
        <ul>
          <li>Più semplice da utilizzare</li>
          <li>Non necessita di alcun aggiornamento</li>
          <li>Funzionamento Offline</li>
        </ul>
      ),
      description: "Lo STUDIO B.A.E.S. nasce con l’intento di voler modernizzare la figura dell’amministratore condominiale, mettendo al servizio delle singole famiglie un SERVIZIO PROFESSIONALE",
    })
      .then(() => alert("App installata correttamente o istruzioni per l'installazione visualizzate"))
      .catch(() => alert("L'utente ha rinunciato all'installazione"));
  };

  return (
    <div>
      {/*<p>
        If your browser is supported and you haven't already installed the app, you should see the install
        button below:
      </p>*/}
          
          {/* <button type="button" onClick={handleClick} style={{ marginBottom: "50px", display: "block" }}>
            Install app
          </button> */}

      <div>
       
      {supported() && !isInstalled() && (

        <a onClick={handleClick} id="install" className="nav-installapp"><AiOutlineAppstoreAdd /> </a>

      )}
      </div>
      {/* <p>supported: {supported() + ""}</p>
        <p>isInstalled: {isInstalled() + ""}</p>    */}
    </div>
  );
}

export default Install;
